import React from "react";

const CaseStudiesGuide = () => {
  return <div>CaseStudiesGuide</div>;
};

export default CaseStudiesGuide;
